import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { FormHelperText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { withTranslation } from 'react-i18next';

class GenericForm extends Component {
  constructor(props) {
    super(props);
    this.node = null;
    this.invalidNodes = [];
    this.keys = Object.keys(props.schema);
    this.state = this.setInitialState(this.keys);
  }

  setInitialState = (keys) => {
    const object = {
      submited: false,
    };
    keys.forEach((key) => {
      object[`${key}_err`] = '';
    });
    return object;
  };

  setNodes = () => {
    const node = ReactDOM.findDOMNode(this);
    if (node instanceof HTMLElement) {
      this.node = node;
      this.configSubmit(node);
      this.configFormAttr(node);
    }
  };

  handleUpdateInvalidNodes = (schemaKey, i) => {
    const validationObject = {};
    validationObject[schemaKey] = { message: '', index: 0 };
    validationObject[schemaKey].message = this.props.schema[schemaKey].errorMessage[i];
    validationObject[schemaKey].index = i;
    this.invalidNodes.push(validationObject);
  };

  checkValidAndOptNodeIfExist = (value, schemaKey, isValidFunc, i) => {
    const lackOfOptionalValue = !this.props.schema[schemaKey].optionalvalue;
    if (lackOfOptionalValue) {
      if (!isValidFunc(value)) {
        this.handleUpdateInvalidNodes(schemaKey, i);
        return true;
      }
      this.cleanInvalidNode(schemaKey, i);
      return false;
    }
    const optionalValue = this.getChildNode(this.props.schema[schemaKey].optionalvalue).value;

    if (!isValidFunc(value, optionalValue)) {
      this.handleUpdateInvalidNodes(schemaKey, i);
      return true;
    }
    this.cleanInvalidNode(schemaKey, i);
    return false;
  };

  verifyIfInvalidNodes = () => {
    const { keys } = this;
    keys.forEach((key) => {
      const childNode = this.getChildNode(key);
      const schemaKey = this.props.schema[key];
      schemaKey.isValid.forEach((isValidFunc, i) => {
        if (childNode === undefined) console.log('undifined', key);
        const value = ['text', 'password'].includes(schemaKey.type)
          ? childNode.value
          : schemaKey.type === 'select'
          ? childNode.nextSibling.value
          : '';
        this.checkValidAndOptNodeIfExist(value, key, isValidFunc, i);
      });
    });
  };

  verifyIfInvalidNode = (schemaKey, value) => {
    for (let i = 0; i < this.props.schema[schemaKey].isValid.length; ++i) {
      if (
        this.checkValidAndOptNodeIfExist(
          value,
          schemaKey,
          this.props.schema[schemaKey].isValid[i],
          i
        )
      ) {
        break;
      }
    }
    return this.invalidNodes.find((it) => it[schemaKey] !== undefined) !== undefined;
  };

  getChildNode = (key) => this.node.querySelector(`#${key}`);

  cleanInvalidNodes = () => {
    this.invalidNodes.forEach((nodeId) => {
      const name = Object.keys(nodeId)[0];
      const newState = {};
      newState[`${name}_err`] = '';
      this.setState(newState);
    });
    this.invalidNodes = [];
  };

  cleanInvalidNode = (schemaKey, index_) => {
    this.invalidNodes = this.invalidNodes.filter(
      (it) =>
        it[schemaKey] === undefined ||
        (it[schemaKey] !== undefined && it[schemaKey].index !== index_)
    );
  };

  configSubmit = (node) => {
    const submitButton = node.querySelector("button[type='submit']");
    if (submitButton) submitButton.onclick = this.onSubmit;
  };

  configFormAttr = (node) => {
    const { keys } = this;
    keys.forEach((key) => {
      const childNode = this.getChildNode(key);
      if (childNode) {
        if (childNode.nextElementSibling && childNode.nextElementSibling.tagName === 'INPUT') {
          childNode.nextElementSibling.onchange = this.handleFormAttrChange(key);
        } else {
          childNode.oninput = this.handleFormAttrChange(key);
        }
      }
    });
  };

  addClassError = (node) => (e) => {
    node.parentNode.classList.add('Mui-error');
  };

  removeClassError = (node) => (e) => {
    node.parentNode.classList.remove('Mui-error');
  };

  handleFormAttrChange = (key) => (e) => {
    if (!this.state.submited) {
      return;
    }
    const node = this.getChildNode(key);
    setTimeout(() => {
      if (this.verifyIfInvalidNode(key, e.target.value)) {
        const newState = {};
        newState[`${key}_err`] = this.invalidNodes.reverse().find((it) => it[key] !== undefined)[
          key
        ].message;
        this.setState(newState);
        node.onblur = this.addClassError(node);
      } else {
        const newState = {};
        newState[`${key}_err`] = '';
        this.setState(newState);
        node.onblur = this.removeClassError(node);
      }
    }, 100);
  };

  handleSubmit = (e) => {
    if (this.invalidNodes.length > 0) {
      this.invalidNodes.forEach((nodeId) => {
        const name = Object.keys(nodeId)[0];
        const newState = {};
        newState[`${name}_err`] = this.invalidNodes.find((it) => it[name] !== undefined)[
          name
        ].message;
        this.setState(newState);
      });
    } else {
      this.props.onSubmit(e);
    }
  };

  onSubmit = (e) => {
    this.cleanInvalidNodes();
    this.verifyIfInvalidNodes();
    this.handleSubmit(e);
    this.setState({
      submited: true,
    });
  };

  componentDidMount() {
    this.setNodes();
  }

  render() {
    const { t, tReady, ...other } = this.props;
    return (
      <Grid {...other} id="generic-form-full-container">
        {other.children.map((child, i) => {
          const key = this.keys.find((it) => it === child.props.id);
          const errorValue = this.state[`${key}_err`];

          if (key !== undefined) {
            return (
              <Grid key={i} {...child.props.gridProps}>
                <FormHelperText spacing={10} component="div" error>
                  {errorValue.length > 0
                    ? React.cloneElement(child, {
                        error: true,
                        helperText: t(errorValue),
                        caption: t(errorValue),
                        index: i,
                      })
                    : React.cloneElement(child, {
                        index: i,
                      })}
                </FormHelperText>
              </Grid>
            );
          }
          return (
            <Grid key={i} {...child.props.gridProps}>
              <FormHelperText spacing={10} component="div" error={false}>
                {child}
                {child.props.optional && (
                  <span className="opcional">
                    {child.props.optionalLabel || t('common.optional')}
                  </span>
                )}
              </FormHelperText>
            </Grid>
          );
        })}
      </Grid>
    );
  }
}

GenericForm.PropType = {
  submitButtonId: PropTypes.string,
  schema: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default withTranslation()(GenericForm);
